import pro1 from "../assets/project1.jpg";
import pro2 from "../assets/project2.jpg";
import pro3 from "../assets/project3.jpeg";
import pro4 from "../assets/project4.jpg";
import pro5 from "../assets/project5.jpg";

const ProjectCardData = [
    {
        imgsrc: pro1,
        title: "Mini Blog Website",
        text: "This is a blogging based website where you can write your blog and user can read it and review it in this author can perform crud operation.",
        view: "https://github.com/rukmani4746/backend-training/tree/mini-proj-49-group-excellent"
    },

    {
        imgsrc: pro2,
        title: "open to intern website",
        text: "If you are finding any internship for that created one website where you can register and get internship.now a days many companies provide internship and apply",
        view: "https://github.com/rukmani4746/backend-training/tree/project/opentointern51"
    },

    {
        imgsrc: pro3,
        title: "Book Management",
        text: "Book management basically a website about to reading books online and you can review it.",
        view: "https://github.com/rukmani4746/backend-training/tree/project/booksManagementGroup55"
    },

    {
        imgsrc: pro4,
        title: "url-shortener",
        text: "this is about url shorting where you can short the url from long url to short url it takes less memory and no need to take tension.",
        view: "https://github.com/rukmani4746/backend-training/tree/project/urlShortnerGroup28"
    },

    {
        imgsrc: pro5,
        title: "Product Management",
        text: "This is a commercial website where you can create account and order product also can add to cart can be perform crud operations like create read update and delete.",
        view: "https://github.com/rukmani4746/backend-training/tree/project/productsManagementGroup26"
    }
]

export default ProjectCardData;